import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78272 1.49965C10.2037 0.83345 11.7962 0.83345 13.2172 1.49965L19.9084 4.63664C21.3639 5.31899 21.3639 7.68105 19.9084 8.3634L13.2173 11.5004C11.7963 12.1665 10.2038 12.1665 8.78281 11.5004L2.0916 8.3634C0.63613 7.68101 0.63614 5.31895 2.0916 4.63659L8.78272 1.49965Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 6.5V12",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 9.5V14.6254C18 15.6334 17.4965 16.5772 16.6147 17.0656C15.1463 17.8787 12.796 19 11 19C9.204 19 6.8537 17.8787 5.38533 17.0656C4.5035 16.5772 4 15.6334 4 14.6254V9.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgLearn;
